export function downloadFile(file) {
  const anchorElement = document.createElement('a');
  anchorElement.href = file.originalUrl;
  anchorElement.style.display = 'none';
  document.body.appendChild(anchorElement);
  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  anchorElement.dispatchEvent(clickEvent);
  document.body.removeChild(anchorElement);
}

export const getFileExtension = (fileName) => {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts[parts.length - 1] : '';
};
